module.exports = __webpack_public_path__ + "static/media/18.0d9599a6.jpg";